import React from "react";

export default function CustomAmountPopup({
  customAmount,
  setCustomAmount,
  onSubmit,
  onClose,
}) {
  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div
        className="popup-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "300px" }}
      >
        <div className="popup-header">
          <span>Enter Amount</span>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div
          className="popup-body"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <input
            type="number"
            min="1"
            placeholder="Enter Amount"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
            style={{
              padding: "12px",
              fontSize: "16px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              width: "100%",
              textAlign: "center",
            }}
          />

          <button
            style={{
              padding: "12px 0",
              backgroundColor: "#6772E5",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={onSubmit}
          >
            Enter
          </button>
        </div>
      </div>
    </div>
  );
}
